import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  DatePicker,
  Select,
  Button,
  Typography,
  Divider,
  Row,
  Col,
  Space,
  message,
  Checkbox,
} from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "./DailyStatusReport.css";
import { getAllAssignedTaskByUserId } from "../../../redux/rtk/features/projectManagement/project/assignedTask/assignedTask";
import { addSingleAssignedTask } from "../../../redux/rtk/features/projectManagement/project/assignedTask/assignedTask";
import getUserFromToken from "../../../utils/getUserFromToken";
import { useDispatch, useSelector } from "react-redux";
import { loadAllTaskStatusByProjectId } from "../../../redux/rtk/features/projectManagement/project/taskStatus/taskStatus";
import { useParams } from "react-router-dom";

const { TextArea } = Input;
const { Text } = Typography;
const { Option } = Select;

const DailyStatusReport = () => {
  const { id } = useParams("id");
  const { list: statusList = [] } = useSelector((state) => state?.taskStatus);
  const assignTaskList = useSelector((state) => state?.AssignedTask?.list);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(1, "day"));
  const [notes, setNotes] = useState("");
  const userId = getUserFromToken();
  const dispatch = useDispatch();

  const userFirstName = assignTaskList?.[0]?.assignedUserFirstName || "User";
  const userLastName = assignTaskList?.[0]?.assignedUserLastName || "";

  const initialTasks =
    assignTaskList
      ?.filter((task) => task.taskStatusId !== "DONE")
      .map((task) => ({
        id: task.id,
        taskId: task.taskId,
        taskName: task.taskName,
        taskStartDate: task.taskStartDate,
        taskEndDate: task.taskEndDate,
        completionTime: task.completionTime,
        statusId: task.taskStatusId,
        selected: false, // Add selected property
      })) || [];

  const [tasks, setTasks] = useState(initialTasks);

  useEffect(() => {
    if (userId) {
      dispatch(getAllAssignedTaskByUserId(userId));
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (assignTaskList && assignTaskList.length > 0) {
      const projectId = assignTaskList[0]?.projectId;
      if (projectId) {
        dispatch(loadAllTaskStatusByProjectId(projectId));
      }

      if (assignTaskList[0]?.taskStartDate) {
        setStartDate(dayjs(assignTaskList[0].taskStartDate));
      }
      if (assignTaskList[0]?.taskEndDate) {
        setEndDate(dayjs(assignTaskList[0].taskEndDate));
      }

      const existingTasks = assignTaskList
        .filter((task) => task.taskStatus !== "DONE")
        .map((task) => ({
          id: task.id,
          taskId: task.taskId,
          taskName: task.taskName,
          taskStartDate: task.taskStartDate,
          taskEndDate: task.taskEndDate,
          completionTime: task.completionTime,
          statusId: task.taskStatusId,
          selected: false, // Add selected property
        }));

      setTasks((prevTasks) => [
        ...existingTasks,
        ...prevTasks.filter((task) => !task.taskStartDate),
      ]);
    }
  }, [assignTaskList, dispatch]);

  const handleTaskChange = (index, key, value) => {
    const updatedTasks = [...tasks];
    updatedTasks[index][key] = value;
    setTasks(updatedTasks);
  };

  // Handle checkbox change
  const handleTaskSelect = (index, checked) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].selected = checked;
    setTasks(updatedTasks);
  };

  const addTask = () => {
    setTasks([
      ...tasks,
      {
        taskName: "",
        completionTime: "",
        statusId: statusList.find((s) => s.name === "TODO")?.id || 1,
        selected: false, // Initialize new tasks with selected = false
      },
    ]);
  };

  const removeTask = (index) => {
    const updated = tasks.filter((_, i) => i !== index);
    setTasks(updated);
  };

  const handleSubmit = async () => {
    const selectedTasks = tasks.filter((task) => task.selected);
  
    if (selectedTasks.length === 0) {
      message.warning("Please select at least one task to submit.");
      return;
    }
  
    for (const task of selectedTasks.filter((t) => t.id)) {
      const values = {
        taskId: parseInt(task.taskId),
        taskStatusId: parseInt(task.statusId),
        ActualStartDateTime: task.taskStartDate
          ? new Date(task.taskStartDate).toISOString()
          : new Date().toISOString(),
        ActualEndDateTime: task.taskEndDate
          ? new Date(task.taskEndDate).toISOString()
          : null,
        updateBy: parseInt(userId),
        note: notes || "",
      };
  
      try {
        await dispatch(addSingleAssignedTask(values)).unwrap();
        message.success(`Task "${task.taskName}" status history added successfully!`);
      } catch (error) {
        message.error(`Failed to add status history for task "${task.taskName}".`);
        console.error("Error details:", error);
      }
    }
  
    // ✅ Refresh task list after submit
    if (userId) {
      dispatch(getAllAssignedTaskByUserId(userId));
    }
  
    message.success(`Report submitted successfully with ${selectedTasks.length} tasks!`);
  };
  

  // const handleSubmit = async () => {
  //   // Filter only selected tasks
  //   const selectedTasks = tasks.filter((task) => task.selected);

  //   if (selectedTasks.length === 0) {
  //     message.warning("Please select at least one task to submit.");
  //     return;
  //   }

  //   console.log({
  //     startDate,
  //     endDate,
  //     tasks: selectedTasks, // Only include selected tasks
  //     notes,
  //   });

  //   // Insert new task status history records for each selected task
  //   for (const task of selectedTasks.filter((t) => t.id)) {
  //     const values = {
  //       taskId: parseInt(task.taskId),
  //       taskStatusId: parseInt(task.statusId),
  //       ActualStartDateTime: task.taskStartDate
  //         ? new Date(task.taskStartDate).toISOString()
  //         : new Date().toISOString(),
  //       ActualEndDateTime: task.taskEndDate
  //         ? new Date(task.taskEndDate).toISOString()
  //         : null,
  //       updateBy: parseInt(userId),
  //       note: notes || "",
  //     };

  //     console.log("Submitting values:", values);

  //     try {
  //       await dispatch(addSingleAssignedTask(values)).unwrap();
  //       message.success(
  //         `Task "${task.taskName}" status history added successfully!`
  //       );
  //     } catch (error) {
  //       message.error(
  //         `Failed to add status history for task "${task.taskName}".`
  //       );
  //       console.error("Error details:", error);
  //     }
  //   }

  //   message.success(
  //     `Report submitted successfully with ${selectedTasks.length} tasks!`
  //   );
  // };

  return (
    <Card bordered={false}>
      <div
        style={{
          background: "linear-gradient(to right, #722ed1, #1890ff)",
          padding: "16px 24px",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "-24px -24px 24px -24px",
        }}
      >
        <div>
          <div style={{ fontSize: 20, fontWeight: 600 }}>
            Daily Status Report
          </div>
          <div style={{ fontSize: 14 }}>
            {userFirstName} {userLastName}
          </div>
        </div>
        <div style={{ fontSize: 14 }}>
          {/* {startDate.format("dddd, MMMM D, YYYY")} -{" "}
          {endDate.format("dddd, MMMM D, YYYY")} */}

          {dayjs().format("dddd, MMMM D, YYYY")}
        </div>
      </div>

      <Divider orientation="left">Tasks</Divider>

      {tasks.map((task, index) => (
        <div
          key={index}
          style={{
            padding: "12px 16px",
            marginBottom: 16,
            background: task.selected ? "#f0f5ff" : "#fafafa", // Highlight selected tasks
            borderRadius: 8,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
          }}
        >
          <Row gutter={16} align="middle">
            <Col span={1}>
              <Checkbox
                checked={task.selected}
                onChange={(e) => handleTaskSelect(index, e.target.checked)}
              />
            </Col>
            <Col span={5}>
              <Input
                placeholder="Task Name"
                value={task.taskName}
                onChange={(e) =>
                  handleTaskChange(index, "taskName", e.target.value)
                }
                disabled={!!task.taskStartDate}
              />
            </Col>
            <Col span={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={task.taskStartDate ? dayjs(task.taskStartDate) : null}
                onChange={(date) =>
                  handleTaskChange(
                    index,
                    "taskStartDate",
                    date ? date.toISOString() : null
                  )
                }
              />
            </Col>
            <Col span={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={task.taskEndDate ? dayjs(task.taskEndDate) : null}
                onChange={(date) =>
                  handleTaskChange(
                    index,
                    "taskEndDate",
                    date ? date.toISOString() : null
                  )
                }
              />
            </Col>
            <Col span={4}>
              <Input
                placeholder="Completion Time"
                value={task.completionTime}
                onChange={(e) =>
                  handleTaskChange(index, "completionTime", e.target.value)
                }
                // disabled={!!task.taskStartDate}
              />
            </Col>
            <Col span={4}>
              <Select
                style={{ width: "100%" }}
                value={task.statusId}
                onChange={(value) => handleTaskChange(index, "statusId", value)}
              >
                {statusList.map((status) => (
                  <Option key={status.id} value={status.id}>
                    {status.name}
                  </Option>
                ))}
              </Select>
            </Col>
            {/* <Col span={2}>
              <Button
                danger
                icon={<MinusCircleOutlined />}
                onClick={() => removeTask(index)}
                style={{
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </Col> */}
          </Row>
        </div>
      ))}

      {/* <Button
        type="dashed"
        onClick={addTask}
        icon={<PlusOutlined />}
        block
        style={{ marginTop: 16 }}
      >
        Add Task
      </Button> */}

      <Divider orientation="left">Notes / Challenges</Divider>
      <TextArea
        rows={4}
        placeholder="Any challenges or observations today?"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />

      <Divider />

      <Row justify="space-between" style={{ marginTop: 24 }}>
        <Col>
          <Text>
            Selected Tasks: {tasks.filter((t) => t.selected).length} of{" "}
            {tasks.length}
          </Text>
        </Col>
        <Col>
          <Button type="primary" onClick={handleSubmit}>
            Submit Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default DailyStatusReport;
